import React from 'react';
import { CardHeader } from './Card';
import { FormGroup } from './Forms';
import RevertableForm from './RevertableForm';

export default class MetaForm extends RevertableForm {
  defaultNewObj = {
    title: '',
    authors: '',
    key: '',
    filename: '',
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="card mb-3" style={{ border: 'none' }}>
        <div className="card-body">
          <CardHeader title="Song details" />

          <FormGroup
            name="title"
            label="Title"
            value={this.props.obj.title}
            onChange={this.handleChange}
          />

          <FormGroup
            name="authors"
            label="Authors"
            value={this.props.obj.authors}
            onChange={this.handleChange}
          />

          <div className="row">
            <div className="col-4">
              <FormGroup
                label="Key"
                name="key"
                value={this.props.obj.key}
                onChange={this.handleChange}
                datalist={[
                  'C',
                  'D',
                  'E',
                  'F',
                  'A',
                  'B',
                  'C#',
                  'D#',
                  'F#',
                  'G#',
                  'A#',
                  'Db',
                  'Eb',
                  'Gb',
                  'Ab',
                  'Bb',
                  'Cm',
                  'Dm',
                  'Em',
                  'Fm',
                  'Am',
                  'Bm',
                  'C#m',
                  'D#m',
                  'F#m',
                  'G#m',
                  'A#m',
                  'Dbm',
                  'Ebm',
                  'Gbm',
                  'Abm',
                  'Bbm',
                ]}
              />
            </div>
            <div className="col-8">
              <FormGroup
                name="filename"
                label="Filename"
                value={this.props.obj.filename}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="mt-5 d-flex w-100 justify-content-between">
            <div />
            {this.getRevertButton()}
            {this.getCreateButton()}
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MetaForm.js